// Feature gating per subscription plan.
//
// Plans are CUMULATIVE: each higher tier includes everything from the lower ones.
// Tier ranks are used to decide whether a feature is unlocked for the current plan.

export const PLAN_RANK = {
  base: 0,
  standard: 1,
  premium: 2,
  enterprise: 3,
};

export const PLAN_LABEL = {
  base: "Base",
  standard: "Standard",
  premium: "Premium",
  enterprise: "Enterprise",
};

// Minimum plan required to unlock each Settings tab.
// Tabs not listed here default to "base" (always unlocked).
export const SETTINGS_TAB_REQUIRED_PLAN = {
  general: "standard",       // Logo + info azienda
  theme: "standard",         // Personalizzazione aspetto (tema colore)
  workweek: "standard",      // Settimana lavorativa + chiusura infrasettimanale
  holidays: "standard",      // Festività locali
  limits: "premium",         // Limiti / configurazione finestra richieste
  notifications: "premium",  // Notifiche email
  visibility: "enterprise",  // Visibilità ferie residue dipendenti
};

/**
 * Check whether the current plan unlocks a feature requiring `requiredPlan`.
 * @param {string} currentPlan - e.g. "base", "standard", "premium", "enterprise"
 * @param {string} requiredPlan - minimum plan needed
 * @returns {boolean}
 */
export const hasAccess = (currentPlan, requiredPlan) => {
  const cur = PLAN_RANK[currentPlan] ?? 0;
  const req = PLAN_RANK[requiredPlan] ?? 0;
  return cur >= req;
};

/**
 * Returns the user-facing label of a plan, e.g. "Premium".
 */
export const getPlanLabel = (planKey) => PLAN_LABEL[planKey] || "Standard";
